import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import Hero from './components/Hero';
import Values from './components/Values';
import People from './components/People';
import Benefits from './components/Benefits';
import Who from './components/Who';
import Timeline from './components/Timeline';
import DoWell from './components/DoWell';

const JoinUsContainer = styled.div`
  font-family: 'Helvetica Now', Arial, sans-serif;
`;

const JoinUs = () => {
  return (
    <JoinUsContainer>
      <Helmet>
        <title>SafetyWing - Join us</title>
        <meta name="description" content="We are building a country on the internet." />
      </Helmet>

      <Hero />
      <Values />
      <People />
      <Benefits />
      <Who />
      <Timeline />
      <DoWell />
    </JoinUsContainer>
  );
};

export default JoinUs;
